<template>
	<div class="link-list">
		<RouterLink
			v-for="(item, idx) in linkList"
			:key="idx"
			:to="item.to"
			class="btn link-list__link"
			>{{ item.text }}</RouterLink
		>
	</div>
</template>
<script>
	export default {
		name: 'StatisticsLinkList',
		computed: {
			linkList() {
				return [
					{
						to: '/operation/statistics/attendance',
						text: '출석체크 통계',
					},
					{
						to: '/operation/statistics/qna',
						text: 'Q&A 통계',
					},
					{
						to: '/operation/statistics/qna-category',
						text: 'Q&A 카테고리 통계',
					},
					{
						to: '/operation/statistics/push',
						text: '푸시/알림함 통계',
					},
					{
						to: '/operation/statistics/event',
						text: '이벤트 통계',
					},
					{
						to: '/operation/statistics/review',
						text: '리뷰 통계',
					},
					{
						to: '/operation/statistics/user-retention',
						text: '유저별 리텐셜 통계',
					},
				].filter(item => item.to !== this.$route.path);
			},
		},
	};
</script>
<style lang="scss" scoped>
	.link-list {
		display: flex;
		height: 37px;
		align-items: center;

		&__link {
			display: block;
			margin-left: 10px;
		}
	}
</style>
